import forEach from 'dcode/functions/forEach'

export default function getAllList (basic) {
  const data = [...basic?.main, ...basic?.other]
  const post = []

  forEach(data, sections => {
    post.push(sections?.value)
    forEach(sections?.list, item => post.push(item?.value))
  })

  return post
}
